import { useEffect, useState } from "react";
import { Modal, Button, theme as antdTheme } from "antd";

export default function InstallPrompt() {
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [showPrompt, setShowPrompt] = useState(false);
    const [isIosPrompt, setIsIosPrompt] = useState(false);
    const { token } = antdTheme.useToken();
    const isIos = () =>
        /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());

    const isInStandaloneMode = () =>
        "standalone" in window.navigator && window.navigator.standalone;

    useEffect(() => {
        if (isIos() && !isInStandaloneMode()) {
            setIsIosPrompt(true);
            setShowPrompt(true);
        }

        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setShowPrompt(true);
        };

        window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
        return () =>
            window.removeEventListener(
                "beforeinstallprompt",
                handleBeforeInstallPrompt
            );
    }, []);

    const handleInstallClick = () => {
        if (deferredPrompt) {
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then(() => {
                setDeferredPrompt(null);
                setShowPrompt(false);
            });
        }
    };

    return (
        <Modal
            open={showPrompt}
            onCancel={() => setShowPrompt(false)}
            centered
            width={420}
            title={
                <div style={{ textAlign: "center" }}>
                    <div
                        style={{
                            fontSize: 36,
                            marginBottom: 8,
                        }}
                    >
                        📲
                    </div>
                    <span style={{ fontWeight: 700 }}>
                        ¿Quieres instalar esta app?
                    </span>
                </div>
            }
            styles={{
                content: {
                    borderRadius: token.borderRadiusLG,
                    backgroundColor: token.colorBgContainer,
                    boxShadow: token.boxShadowSecondary,
                },
                header: {
                    borderBottom: "none",
                },
                footer: {
                    borderTop: "none",
                    paddingTop: 0,
                },
            }}
            footer={
                isIosPrompt
                    ? [
                        <Button
                            key="ok"
                            type="primary"
                            onClick={() => setShowPrompt(false)}
                            style={{
                                width: "100%",
                                height: 44,
                                fontWeight: 700,
                                borderRadius: 12,
                                background: "linear-gradient(135deg, #fadb14, #faad14)",
                                color: "#614700",
                                border: "none",
                            }}
                        >
                            Entendido
                        </Button>,
                    ]
                    : [
                        <Button
                            key="cancel"
                            onClick={() => setShowPrompt(false)}
                            style={{
                                height: 44,
                                borderRadius: 12,
                            }}
                        >
                            No, gracias
                        </Button>,
                        <Button
                            key="install"
                            type="primary"
                            onClick={handleInstallClick}
                            style={{
                                height: 44,
                                fontWeight: 700,
                                borderRadius: 12,
                                background: "linear-gradient(135deg, #fadb14, #faad14)",
                                color: "#614700",
                                border: "none",
                                boxShadow: "0 8px 20px rgba(250, 173, 20, 0.45)",
                            }}
                        >
                            Sí, instalar
                        </Button>,
                    ]
            }
        >
            {isIosPrompt ? (
                <div style={{ marginTop: 8 }}>
                    <p style={{ color: token.colorText }}>
                        Para instalar esta app en tu dispositivo iOS:
                    </p>

                    <ol
                        style={{
                            paddingLeft: 20,
                            color: token.colorTextSecondary,
                        }}
                    >
                        <li>
                            Pulsa el botón de <strong>Compartir</strong> en Safari
                        </li>
                        <li>
                            Selecciona <strong>“Agregar a pantalla de inicio”</strong>
                        </li>
                    </ol>
                </div>
            ) : (
                <p
                    style={{
                        marginTop: 8,
                        color: token.colorTextSecondary,
                        textAlign: "center",
                    }}
                >
                    Puedes instalar esta app en tu dispositivo para acceder más rápido,
                    incluso sin abrir el navegador.
                </p>
            )}
        </Modal>
    );
}
